import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  LocalPermissions,
  Roles,
  RolesListData,
  RolesListParams,
  RolesToPermissions,
  RolesToPermissionsListData,
  RoleToPermissionsPayload,
} from '@/libs/interfaces'

export const rolesApi = {
  create: async (body: Partial<Roles>): Promise<Partial<Roles>> => {
    return await api
      .post<ApiResponse<Partial<Roles>>>(URLs.Roles.create(body.orgID || ''), body)
      .then((response) => response.data.data)
  },
  delete: async (payload: Partial<Roles>) => {
    return await api
      .delete(URLs.Roles.byID(payload.orgID || '', payload.roleID || ''))
      .then((response) => response.data)
  },
  getByID: async (params: Partial<Roles>): Promise<Partial<Roles>> => {
    return await api
      .get<ApiResponse<Partial<Roles>>>(URLs.Roles.byID(params.orgID || '', params.roleID || ''))
      .then((response) => response.data.data)
  },
  list: async (params: RolesListParams): Promise<Roles[]> => {
    const query = buildQueryParams(params)
    return await api
      .get<ApiResponse<RolesListData>>(URLs.Roles.list(params.orgID || '', query))
      .then((response) => response?.data?.data?.roles || [])
  },
  update: async (payload: Partial<Roles>) => {
    return await api
      .patch(URLs.Roles.byID(payload.orgID || '', payload.roleID || ''), payload)
      .then((response) => response.data)
  },
  createRolesToPermissions: async (
    params: Partial<RolesToPermissions>,
    payload: RoleToPermissionsPayload,
  ): Promise<Partial<RolesToPermissionsListData>> => {
    return await api
      .post<
        ApiResponse<RolesToPermissionsListData>
      >(URLs.Roles.rolesPermissionsMapping(params.orgID || '', params.roleID || ''), payload)
      .then((response) => response.data.data)
  },
  getRolesToPermissions: async (params: Partial<Roles>): Promise<LocalPermissions[]> => {
    return await api
      .get<
        ApiResponse<RolesToPermissionsListData>
      >(URLs.Roles.rolesPermissionsMapping(params.orgID || '', params.roleID || ''))
      .then((response) => response?.data?.data?.allPermissionsWithStatus || [])
  },
  deleteRolesToPermissions: async (
    params: Partial<Roles>,
  ): Promise<Partial<RolesToPermissions>> => {
    return await api
      .delete<
        ApiResponse<RolesToPermissions>
      >(URLs.Roles.rolesPermissionsMapping(params.orgID || '', params.roleID || ''))
      .then((response) => response.data.data)
  },
}
